import { ICombinedBAAndDDAssessment } from "@/services/reports/CombinedBudgetAndDDAsessment.types";
import { PDFConfig } from "@/shared/pdf/config";
import { PDFStyles } from "@/shared/pdf/style";
import { Utilities as _utils } from "@/shared/utilities";
import { i18n } from "@/plugins/i18n";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class CombinedBudgetAndDDAsessment implements ICombinedBAAndDDAssessment {
  info: Array<any> = [];

  data: any = {};

  docdefinition: any = {};

  applicationInfo: any;

  userInfo: any;

  index: Array<any>;

  printedDate: string;

  combined: any;

  schema: Array<any> = [];

  sections: Array<any> = [];

  print(userInfo: any, applicationInfo: any, combined: any) {
    this.printedDate = this.formatDate(new Date());
    this.userInfo = userInfo;
    this.applicationInfo = applicationInfo;
    this.combined = combined;
    this.sections = combined.sections || ['budget', 'dueDiligence'];
    this.schema.push(combined.duedeligenceTemp);
    this.buildDocDefinition(this.combined);
    pdfMake
      .createPdf(this.docdefinition)
      .download(
        `Budget_Assessment_Duediligence_Assessment_${applicationInfo.Code || applicationInfo.ApplicationId}.pdf`
      );
  }
  buildDocDefinition(combined) {
    if (this.sections.includes('budget') && (combined.budgetData != null || combined.budgetAsessmentTemp != null)) {
      this.buildDocDefinitionBudgetAsessment(
        combined.budgetData,
        combined.budgetAsessmentTemp
      );
    }
    if (this.sections.includes('dueDiligence') && (combined.ddData != null || combined.duedeligenceTemp != null)) {
      this.buildDocDefinitionDDAssessment(
        combined.duedeligenceTemp,
        combined.ddData
      );
    }
  }
  private formatDate(date: any, format?: string) {
    return _utils.formatDate(date);
  }
  //budgetAssessment
  buildDocDefinitionBudgetAsessment(data, schema) {
    this.docdefinition.content = new Array<any>();
    this.docdefinition.index = new Array<any>();
    this.data = data;
    /** document style css */
    this.docdefinition.styles = PDFStyles.appl;
    /** document page margins */
    this.docdefinition.pageMargins = [50, 65, 50, 45];
    this.createCoverPage(this.applicationInfo);
    this.summaryPage(this.applicationInfo, this.userInfo, this.data);
    this.setHeader();
    this.setFooter(this.userInfo, this.printedDate);
    this.budgetAsessment(data, schema);
  }
  //Creates summary page
  summaryPage(applicationInfo, userInfo, data) {
    let summaryTableEntry = this.summaryTableba(
      applicationInfo,
      userInfo,
      data
    );

    this.docdefinition.content.push(
      {
        canvas: [{ type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" }],
        margin: [0, 0, 0, 40],
        pageBreak: "before",
      },
      {
        text: `${i18n.t('Summary')}`,
        color: "#fff",
        fontSize: 15,
        relativePosition: { x: 20, y: -63 },
      },

      {
        table: {
          widths: ["auto", "*"],
          body: summaryTableEntry,
        },
      }
    );
  }

  private createCoverPage(appInfo) {
    this.docdefinition.content.push({
      text: `${i18n.t('Summary')}`,
      style: ["covertext", "coverTitle"],
      margin: [0, 80, 0, 5],
      alignment: "center",
    });
    this.docdefinition.content.push({
      text: appInfo["Title"] ? appInfo["Title"] : appInfo["Project"],
      style: ["covertext", "header1"],
    });

    this.docdefinition.content.push({
      text: `${i18n.t('Lead partner')}`,
      style: ["covertext", "coverTitle"],
      margin: [0, 30, 0, 5],
      alignment: "center",
    });
    this.docdefinition.content.push({
      text: appInfo["LeadPartner"],
      style: ["covertext", "header1"],
    });
    this.docdefinition.content.push({
      text: "",
      style: ["covertext", "coverTitle"],
      margin: [0, 80, 0, 5],
      alignment: "center",
    });
    this.docdefinition.content.push({
      text: `${i18n.t('Budget Assessment')}`,
      style: ["covertext", "header1"],
    });
  }
  setHeader() {
    this.docdefinition.header = [
      {
        columns: [
          {
            image:
              "data:image/png;base64,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",
            height: 25,
            width: 26,
            margin: 20,
            alignment: "left",
          },
          {
            text: "IUCN Grants Portal",
            style: ["header3"],
            margin: [30, 25],
            alignment: "left",
          },
        ],
      },
    ];
  }
  setFooter(user, printedDate) {
    /** set page footer */
    this.docdefinition.footer = function(
      currentPage: number,
      pageCount: number
    ) {
      if (currentPage > 1)
        return [
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    columns: [
                      {
                        // printed by
                        text:
                          Object.keys(user).length != 0
                            ? `${i18n.t('Printed by')} : ${user["userInfo"]["userName"]}`
                            : "",
                        fontSize: 8,
                        margin: [20, 3, 0, 0],
                        alignment: "left",
                      },
                      {
                        // page number
                        widths: "*",
                        text: "-" + currentPage.toString() + "-",
                        fontSize: 6,
                        margin: [0, 0, 0, 0],
                        alignment: "center",
                      },
                      {
                        // printed date
                        widths: "*",
                        text: printedDate
                          ? `${i18n.t('Printed on')} : ${printedDate}`
                          : "",
                        fontSize: 8,
                        margin: [0, 0, 20, 0],
                        alignment: "right",
                      },
                    ],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function(i: number, node: any) {
                return i == 0 ? 1 : 0;
              },
              vLineWidth: function(i: number, node: any) {
                return i == 1 ? 0 : 0;
              },
            },
          },
        ];
    };
  }

  //Creating  buget assessment for each sections

  budgetAsessment(data, schema) {
    let response = this.buildfromSchema(schema);
    for (let key1 in response) {
      for (let key2 in response[key1]) {
        this.docdefinition.content.push(
          {
            canvas: [
              { type: "rect", x: 0, y: 0, w: 490, h: 26, color: "#19719e" },
            ],
            margin: [0, 0, 0, 20],
            pageBreak: "before",
          },
          {
            text: response[key1][key2].title,
            color: "#fff",
            fontSize: 15,
            relativePosition: { x: 10, y: -43 },
          },

          {
            text: response[key1][key2].description,
            bold: "true",
            margin: [0, 10],
          }
        );
        for (let key3 in response[key1][key2]) {
          if (Array.isArray(response[key1][key2][key3])) {
            let options = this.options(response[key1][key2][key3]);
            let answers = this.selections(
              response[key1][key2][key3],
              key3,
              key2
            );

            this.docdefinition.content.push(
              {
                text: response[key1][key2][key3].title,
                bold: "true",
                margin: [0, 10],
              },
              { columns: options, columnGap: 3 },
              {
                columns: answers,
                columnGap: 3,
              }
            );
          }
        }

        let comments = this.comments(key2);

        this.docdefinition.content.push({
          text: `${i18n.t('Comments')}`,
          bold: "true",
          margin: [0, 15],
        });
        if (comments) {
          comments.forEach((element) => {
            this.docdefinition.content.push(
              {
                text: `${element.createdBy} | ${_utils.dateFormat(
                  element.createdOn
                )}`,
                bold: true,
                margin: [0, 2],
              },
              {
                text: `${element.comment}`,
                margin: [0, 2],
              }
            );
          });
        } else {
          this.docdefinition.content.push({
            text: `${i18n.t('No comments')}`,
          });
        }
      }
    }
  }

  //generates options for each assessment questions

  options(data) {
    let options = [];
    data.forEach((element) => {
      options.push({ width: "auto", text: element.title, margin: [27, 0] });
    });
    return options;
  }

  //Generates answers according to user input

  selections(schema, key3, key2) {
    let answers = [];
    let no = false;
    let yes = false;
    let not = false;

    for (let key in this.data) {
      if (key == key2) {
        if (this.data[key2][key3] == "yes") {
          yes = true;
        }
        if (this.data[key2][key3] == "no") {
          no = true;
        }
        if (this.data[key2][key3] == "null") {
          not = true;
        }
      }
    }
    schema.forEach((element) => {
      if (
        (element.title == "Yes" && yes == true) ||
        (element.title == "Oui" && yes == true) ||
        (element.title == "Not applicable" && not == true) ||
        (element.title == "N'est pas applicable" && not == true) ||
        (element.title == "No" && no == true)||
        (element.title == "Non" && no == true)
      ) {
        answers.push({
          width: "auto",
          margin: [24, 0],
          table: {
            widths: ["*"],
            body: [[{ text: "√", fontSize: 10, margin: [6, 2] }]],
          },
        });
      } else {
        answers.push({
          width: "auto",
          margin: [24, 0],
          table: {
            widths: ["*"],
            body: [[{ text: "", margin: [8, 8] }]],
          },
        });
      }
    });
    return answers;
  }

  //Generates Pdf layout from schema

  buildfromSchema(info) {
    let Sections = {};
    for (let key1 in info["properties"]) {
      Sections[info["properties"][key1]["title"]] = {};
      for (let key2 in info["properties"][key1]["properties"]) {
        Sections[info["properties"][key1]["title"]][key2] = {};
        Sections[info["properties"][key1]["title"]][key2][
          "title"
        ] = `${info["properties"][key1]["title"]}`;
        Sections[info["properties"][key1]["title"]][key2]["description"] =
          info["properties"][key1]["properties"][key2]["description"];
        for (let key3 in info["properties"][key1]["properties"][key2][
          "properties"
        ]) {
          // console.log(info['properties'][key1]['properties'][key2]['properties'][key3]['title'])
          if (key3 != "comments") {
            Sections[info["properties"][key1]["title"]][key2][key3] =
              info["properties"][key1]["properties"][key2]["properties"][key3][
                "oneOf"
              ];
            Sections[info["properties"][key1]["title"]][key2][key3]["title"] =
              info["properties"][key1]["properties"][key2]["properties"][key3][
                "title"
              ];
          }
        }
      }
    }
    return Sections;
  }

  // Prints comments for each sections

  comments(key6) {
    for (let key in this.data) {
      if (key == key6) {
        return this.data[key]["comments"];
      }
    }
  }

  //Generates summary information table

  summaryTableba(applicationInfo, userInfo, data) {
    let updatedDate
    if( data["auditInfo"])
    {
      updatedDate=data["auditInfo"]["updatedDate"]?this.formatDate(data["auditInfo"]["updatedDate"],'DD/MM/YYYY - h:mm a'):""
    }
    let appInfoBody = [];
    let conclusion = "";
    if (data["conclusion"]) {
      if (data["conclusion"] == 1) {
        conclusion = "Accepted";
      } else if (data["conclusion"] == 2) {
        conclusion = "Revision Required";
      } else if (data["conclusion"] == 3) {
        conclusion = "Not Recomended";
      }
    }
    appInfoBody.push(
      [
        {
          margin: [0, 5],
          text: `${i18n.t('Reference number of the proposal')}`,
          bold: true,
        },
        {
          margin: [0, 5],
          text: applicationInfo["Code"] || applicationInfo["ApplicationId"],
          link: `${process.env.VUE_APP_Base_URL}/ViewApplication/?appId=${applicationInfo["ApplicationId"]}`,
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Title of the proposal')}`, bold: true },
        {
          margin: [0, 5],
          text: applicationInfo["Title"]
            ? applicationInfo["Title"]
            : applicationInfo["Project"],
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Country')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["Country"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Budget requested(Total budget)')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["RequestedAmount"]+" ("+applicationInfo["TotalProjectBudget"]+")"},
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Name of lead organisation')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["LeadPartner"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Budget Assessment Completed By')}`, bold: true },
        {
          margin: [0, 5],
          text: userInfo["userInfo"]["updatedUserBa"]
            ? userInfo["userInfo"]["updatedUserBa"]
            : "",
        },
      ],
      [
        {
          margin: [0, 5],
          text: `${i18n.t('Assessment completed on')}`,
          bold: true,
        },
        {
          margin: [0, 5],
          text: updatedDate
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Name of lead organisation')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["LeadPartner"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Budget Assessment')}`, bold: true },
        { margin: [0, 5], text: conclusion },
      ]
    );
    return appInfoBody;
  }
  //DDAsessment
  buildDocDefinitionDDAssessment(schema, data) {
    this.data = data;
    /** document style css */
    this.docdefinition.styles = PDFStyles.appl;

    /** document page margins */
    this.docdefinition.pageMargins = [50, 65, 50, 20];
    this.setHeaderDD();
    this.createCoverPagebDD(this.applicationInfo);
    this.summaryPagedDD(this.applicationInfo, this.userInfo, this.data);
    this.setFooterDD(this.userInfo);
    this.scoreCard(this.schema, this.data, this.userInfo);
  }

  //Creates summary page

  summaryPagedDD(applicationInfo, userInfo, data) {
    let summaryTableEntry = this.summaryTable(applicationInfo, userInfo, data);

    this.docdefinition.content.push(
      {
        canvas: [{ type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" }],
        margin: [0, 0, 0, 40],
        pageBreak: "before",
      },
      {
        text: `${i18n.t('Summary')}`,
        color: "#fff",
        fontSize: 15,
        relativePosition: { x: 20, y: -63 },
      },

      {
        table: {
          widths: ["auto", "*"],
          body: summaryTableEntry,
        },
      }
    );
  }

  private createCoverPagebDD(appschema) {
    this.docdefinition.content.push({
      text: `${i18n.t('Project title')}`,
      style: ["covertext", "coverTitle"],
      margin: [0, 80, 0, 5],
      alignment: "center",
      pageBreak: "before",
    });
    this.docdefinition.content.push({
      text: appschema["Title"] ? appschema["Title"] : appschema["Project"],
      style: ["covertext", "header1"],
    });

    this.docdefinition.content.push({
      text: `${i18n.t('Lead partner')}`,
      style: ["covertext", "coverTitle"],
      margin: [0, 30, 0, 5],
      alignment: "center",
    });
    this.docdefinition.content.push({
      text: appschema["LeadPartner"],
      style: ["covertext", "header1"],
    });
    this.docdefinition.content.push({
      text: "",
      style: ["covertext", "coverTitle"],
      margin: [0, 80, 0, 5],
      alignment: "center",
    });
    this.docdefinition.content.push({
      text: `${i18n.t('Due Diligence and Financial Capacity Assessment')}`,
      style: ["covertext", "header1"],
    });
  }
  setHeaderDD() {
    this.docdefinition.header = [
      {
        columns: [
          {
            image:
              "data:image/png;base64,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",
            height: 25,
            width: 26,
            margin: 20,
            alignment: "left",
          },
          {
            text: "IUCN Grants Portal",
            style: ["header3"],
            margin: [30, 25],
            alignment: "left",
          },
        ],
      },
    ];
  }
  setFooterDD(userInfo) {
    /** set page footer */
    this.docdefinition.footer = function(
      currentPage: number,
      pageCount: number
    ) {
      if (currentPage > 1)
        return [
          {
            columns: [
              {
                // printed by
                text: `${i18n.t('Printed by')}  :  ${userInfo["userInfo"]["userName"]}`,
                fontSize: 8,
                margin: [20, 3, 0, 0],
                alignment: "left",
              },
              {
                // page number
                text: "-" + currentPage.toString() + "-",
                fontSize: 6,
                margin: [0, 3, 0, 0],
                alignment: "center",
              },
              {
                // printed date
                text: `${i18n.t('Printed on')}  :  ${userInfo["modifiedAt"]}`,
                fontSize: 8,
                margin: [0, 3, 20, 0],
                alignment: "right",
              },
            ],
          },
        ];
    };
  }

  //Creates assessment score tables for each catagorie

  scoreCard(schema, data, userInfo) {
    let riskCategorie = this.buildfromSchemadd(schema);
    let updatedDate
    if( data["auditInfo"])
    {
      updatedDate=data["auditInfo"]["updatedDate"]?this.formatDate(data["auditInfo"]["updatedDate"],'DD/MM/YYYY - h:mm a'):""
    }
    for (let key5 in riskCategorie) {
      if (riskCategorie[key5].hasOwnProperty("x-class") == false) {
        this.docdefinition.content.push(
          {
            canvas: [
              { type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" },
            ],
            margin: [0, 0, 0, 20],
            pageBreak: "before",
          },
          {
            text: `${i18n.t(key5)}`,
            color: "#fff",
            fontSize: 15,
            relativePosition: { x: 3, y: -43 },
          }
        );

        for (let key6 in riskCategorie[key5]) {
          this.docdefinition.content.push({
            text: `${i18n.t(riskCategorie[key5][key6]["Group"])}`,
            bold: "true",
            margin: [4, 5, 0, 5],
          });
          for (let key7 in riskCategorie[key5][key6]) {
            if (Array.isArray(riskCategorie[key5][key6][key7])) {
              this.docdefinition.content.push(
                {
                  margin: [0, 15, 0, 0],
                  columns: [
                    {
                      width: "*",
                      table: {
                        widths: ["*"],

                        body: [
                          [
                            {
                              text:
                              `${i18n.t(riskCategorie[key5][key6][key7]["description"])}`,
                              fillColor: "#ddd",
                              bold: "true",
                            },
                          ],
                        ],
                      },
                    },
                  ],
                },
                {
                  table: {
                    widths: ["15%", "75%", "*"],
                    body: [
                      [
                        {
                          text: `${i18n.t('Risk level')}`,
                          alignment: "center",
                          bold: "true",
                        },
                        {
                          text: `${i18n.t(riskCategorie[key5][key6][key7]["title"])}`,
                          alignment: "center",
                          bold: "true",
                        },
                        { text: `${i18n.t('Score')}`, alignment: "center", bold: true },
                      ],
                    ],
                  },
                }
              );
              let tableschema = this.tableData(riskCategorie[key5][key6][key7]);

              let riskScore = this.riskAssessment(key7, data);
              //to align the score centrally
              var computedMargin = (tableschema.values.length / 2) * 6.9 + 7;

              this.docdefinition.content.push({
                table: {
                  widths: ["15%", "75%", "*"],
                  body: [
                    [
                      {
                        columns: [
                          {
                            stack: tableschema.values,
                            alignment: "center",
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            stack: tableschema.descriptions,
                            alignment: "center",
                          },
                        ],
                      },
                      {
                        margin: [0, computedMargin],
                        text: riskScore,
                        alignment: "center",
                        bold: "true",
                        fontSize: 20,
                      },
                    ],
                  ],
                },
              });

              let comments = this.Comments(key7, data);

              this.docdefinition.content.push({
                text: `${i18n.t('Comments')}`,
                bold: "true",
                margin: [4, 2],
              });
              if (comments) {
                comments.forEach((element) => {
                  this.docdefinition.content.push(
                    {
                      text: `${element.commentedBy} | ${_utils.dateFormat(
                        element.commentedOn
                      )}`,
                      bold: true,
                      margin: [4, 2],
                    },
                    {
                      text: `${element.comment}`,
                      margin: [4, 8],
                    }
                  );
                });
              } else {
                this.docdefinition.content.push({
                  text: `${i18n.t('No comments')}`,
                  margin: [4, 8],
                });
              }
            }
          }
        }
      }
    }

    this.docdefinition.content.push(
      {
        canvas: [{ type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" }],
        margin: [0, 0, 0, 20],
        pageBreak: "before",
      },
      {
        text: `${i18n.t('Risk Assessment')}`,
        color: "#fff",
        fontSize: 15,
        relativePosition: { x: 3, y: -43 },
      }
    );
   //ASSESSMENT AND RECOMMENDATION
    for (let key in riskCategorie) {
      if (riskCategorie[key].hasOwnProperty("x-class")) {
        for (let key1 in riskCategorie[key]) {
          if (key1 != "x-class") {
            if (riskCategorie[key][key1]["type"] == "string") {
              for (let key2 in riskCategorie[key][key1]) {
                if (key2 != "type") {
                  this.docdefinition.content.push({
                    margin: [0, 5],
                    text: riskCategorie[key][key1][key2],
                    bold: "true",
                  });
                this.docdefinition.content.push({
                  text: data[key2]?data[key2]:"",
                });
                }
              }
            }
            if (riskCategorie[key][key1]["type"] == "boolean") {
              for (let key2 in riskCategorie[key][key1]) {
                if (key2 == "group") {
                  this.docdefinition.content.push({
                    margin: [0, 5],
                    text: riskCategorie[key][key1][key2],
                    bold: "true",
                  });
                } else if (key2 != ("type" || "group")) {
                  if(data[key2]==true)
                  {
                    this.docdefinition.content.push({
                      columns:[
                        {
                      width: "5%",
                      margin: [0,10],
                      table: {
                        widths: ["*"],
                        body: [[{ text: "√", fontSize: 10 ,margin:[6, 2]}]],
                      },
                    },
                    {
                      width: "auto",
                      margin:[10, 13],
                      text:riskCategorie[key][key1][key2]
                    }
                    ]
                    });
                }
                else
                {
                  this.docdefinition.content.push( {
                    columns:[
                      {
                    width: "5%",
                    margin: [0,10],
                    table: {
                      widths: ["*"],
                      body: [[{ text: "",margin: [8, 8] }]],
                    }
                  },
                    {
                      width: "auto",
                      margin: [7, 15],
                      text:riskCategorie[key][key1][key2]
                    }
                  ]
                  });
                }
              }
            }
          }
            if (riskCategorie[key][key1]["type"] == "number") {
              for (let key2 in riskCategorie[key][key1]) {
                if (key2 == "group") {
                  this.docdefinition.content.push({
                    margin: [0, 10],
                    columns: [
                      {
                        width: "auto",
                        text: `${riskCategorie[key][key1][key2]}`,
                      },
                      {
                        margin: [3, 0, 0, 10],
                        width: "*",
                        text: this.getConclusion(data["conclusion"]),
                      },
                    ],
                    bold: "true",
                  });
                }
              }
            }
          }
        }
      }
    }

    this.docdefinition.content.push({
      columns: [
        {
          width: "80%",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  margin: [0, 13.5],
                  columns: [
                    { width: "auto", text: `${i18n.t('Risk Asessment:')}`, bold: "true" },
                    { width: "auto", text: data["riskLevel"] },
                  ],
                  columnGap: 5,
                },
              ],
              [
                {
                  margin: [0, 15],
                  columns: [
                    { width: "auto", text: `${i18n.t('Completed by:')}`, bold: "true" },
                    {
                      width: "auto",
                      text: userInfo["userInfo"]["updatedUserDd"]
                      ? `${userInfo["userInfo"]["updatedUserDd"]} | ${updatedDate}`
                      : "",
                    },
                  ],
                  columnGap: 5,
                },
              ],
            ],
          },
        },
        {
          width: "20%",
          table: {
            widths: ["*"],
            body: [
              [{ text: `${i18n.t('TotalScore')}`, alignment: "center", bold: "true" }],
              [
                {
                  text: data["totalScore"] ? data["totalScore"] : "0",
                  margin: [0, 26.8],
                  alignment: "center",
                  bold: "true",
                  fontSize: "15",
                },
              ],
            ],
          },
        },
      ],
    });
    return 0;
  }

  //creates layout for the pdf from schema
  //duedeligence
  buildfromSchemadd(schema) {
    let catagories = {};
    Object.keys(schema).forEach((key1) => {
      Object.keys(schema[key1]).forEach((key2) => {
        if (schema[key1][key2]["x-display"] == "group") {
          catagories[schema[key1][key2]["title"]] = {};
          Object.keys(schema[key1][key2]["properties"]).forEach((key3) => {
            catagories[schema[key1][key2]["title"]][key3] = {};
            Object.keys(
              schema[key1][key2]["properties"][key3]["properties"]
            ).forEach((key4) => {
              if (
                Object.keys(
                  schema[key1][key2]["properties"][key3]["properties"][key4]
                ).includes("properties")
              ) {
                catagories[schema[key1][key2]["title"]][key3]["Group"] =
                  schema[key1][key2]["properties"][key3]["title"];
                if (
                  schema[key1][key2]["properties"][key3]["properties"][key4][
                    "x-display"
                  ] == "rating-table"
                ) {
                  catagories[schema[key1][key2]["title"]][key3][key4] =
                    schema[key1][key2]["properties"][key3]["properties"][key4][
                      "properties"
                    ]["score"]["oneOf"];
                  catagories[schema[key1][key2]["title"]][key3][key4][
                    "description"
                  ] = schema[key1][key2]["properties"][key3]["title"];
                  catagories[schema[key1][key2]["title"]][key3][key4]["title"] =
                    schema[key1][key2]["properties"][key3]["properties"][key4][
                      "title"
                    ];
                } else if (
                  schema[key1][key2]["properties"][key3]["properties"][key4][
                    "x-display"
                  ] == "sub-group"
                ) {
                  Object.keys(
                    schema[key1][key2]["properties"][key3]["properties"][key4][
                      "properties"
                    ]
                  ).forEach((key5) => {
                    catagories[schema[key1][key2]["title"]][key3][key4] =
                      schema[key1][key2]["properties"][key3]["properties"][
                        key4
                      ]["properties"][key5]["properties"]["score"]["oneOf"];
                    catagories[schema[key1][key2]["title"]][key3][key4][
                      "description"
                    ] =
                      schema[key1][key2]["properties"][key3]["properties"][
                        key4
                      ]["title"];
                    catagories[schema[key1][key2]["title"]][key3][key4][
                      "title"
                    ] =
                      schema[key1][key2]["properties"][key3]["properties"][
                        key4
                      ]["properties"][key5]["title"];
                  });
                }
              }
            });
          });
        } else {
          catagories[schema[key1][key2]["title"]] = {};
          Object.keys(schema[key1][key2]["properties"]).forEach((key3) => {
            catagories[schema[key1][key2]["title"]][key3] = {};
            catagories[schema[key1][key2]["title"]]["x-class"] =
              schema[key1][key2]["x-class"];
            catagories[schema[key1][key2]["title"]][key3]["group"] =
              schema[key1][key2]["properties"][key3]["title"];
            Object.keys(
              schema[key1][key2]["properties"][key3]["properties"]
            ).forEach((key4) => {
              catagories[schema[key1][key2]["title"]][key3][key4] =
                schema[key1][key2]["properties"][key3]["properties"][key4][
                  "title"
                ];
              catagories[schema[key1][key2]["title"]][key3]["type"] =
                schema[key1][key2]["properties"][key3]["properties"][key4][
                  "type"
                ];
            });
          });
        }
      });
    });
    return catagories;
  }

  // Inserts schemarmations that is required in each table

  tableData(riskCategorie) {
    var descriptions = [];
    var values = [];
    if (Array.isArray(riskCategorie)) {
      riskCategorie.forEach((element) => {
        values.push([{ text: element.const, margin: [0, 5] }]);
        descriptions.push([{ text: element.title, margin: [0, 5] }]);
      });
      return { values: values, descriptions: descriptions };
    }
  }

  //Inserts score for each catagorie

  riskAssessment(key7, data) {
    for (let key in data) {
      if (key == key7) {
        return data[key]["score"];
      }
    }
  }

  //inserts comments for each catagorie

  Comments(key7, data) {
    for (let key in data) {
      if (key == key7) {
        return data[key]["comments"];
      }
    }
  }

  getConclusion(data) {
    switch (data) {
      case 1:
        return `${i18n.t('Recommend for funding')}`;
        break;
      case 2:
        return `${i18n.t('Recommend for funding if additional documents/information is provided')}`;
        break;
      case 3:
        return `${i18n.t('Do NOT Recommend for funding')}`;
        break;
      default:
        break;
    }
  }

  //Generates summary table

  summaryTable(applicationInfo, userInfo, data) {
   
    let updatedDate
    if( data["auditInfo"])
    {
      updatedDate=data["auditInfo"]["updatedDate"]?this.formatDate(data["auditInfo"]["updatedDate"],'DD/MM/YYYY - h:mm a'):""
    }
    let appschemaBody = [];
    let conclusion = "";
    if (data["conclusion"]) {
      conclusion = this.getConclusion(data["conclusion"]);
    }
    appschemaBody.push(
      [
        {
          margin: [0, 5],
          text: `${i18n.t('Reference number of the proposal')}`,
          bold: true,
        },
        {
          margin: [0, 5],
          text: applicationInfo["Code"] || applicationInfo["ApplicationId"],
          link: `${process.env.VUE_APP_Base_URL}/ViewApplication/?appId=${applicationInfo["ApplicationId"]}`,
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Title of the proposal')}`, bold: true },
        {
          margin: [0, 5],
          text: applicationInfo["Title"]
            ? applicationInfo["Title"]
            : applicationInfo["Project"],
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Country')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["Country"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Budget requested(Total budget)')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["RequestedAmount"]+" ("+applicationInfo["TotalProjectBudget"]+")" },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Name of lead organisation')}`, bold: true },
        { margin: [0, 5], text: applicationInfo["LeadPartner"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Risk Assessment')}`, bold: true },
        { margin: [0, 5], text: data["riskLevel"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Conclusion')}`, bold: true },
        { margin: [0, 5], text: conclusion },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Assessment Completed By')}`, bold: true },
        {
          margin: [0, 5],
          text: userInfo["userInfo"]["updatedUserDd"]
            ? userInfo["userInfo"]["updatedUserDd"]
            : "",
        },
      ],
      [
        {
          margin: [0, 5],
          text: `${i18n.t('Assessment completed on')}`,
          bold: true,
        },
        {
          margin: [0, 5],
          text: updatedDate
        },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Grid completed by')}`, bold: true },
        { margin: [0, 5], text: userInfo["userInfo"]["userName"] },
      ],
      [
        { margin: [0, 5], text: `${i18n.t('Total score ')}`, bold: true },
        { margin: [0, 5], text: data["totalScore"] },
      ]
    );
    return appschemaBody;
  }
}
